import { render } from "./DialogRiprogramma.vue?vue&type=template&id=76afb810"
import script from "./DialogRiprogramma.vue?vue&type=script&lang=js"
export * from "./DialogRiprogramma.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__